import React, { useState, useEffect } from "react";
import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Box, Autocomplete, Avatar, createFilterOptions } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useParams,useLocation } from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { getLangKey } from "common/src/other/getLangKey";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  C2_FONT,
  c2TextFieldSx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
} from "../components/conecta2ModalStyles";
import { C2, C2StatusChip } from "../components/Table/C2UserTable";
import FormSection, { c2RtlFieldSx } from "../components/C2FormSection";

const DEFAULT_CAR_IMAGE = "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png";

const driverFilterOptions = createFilterOptions({
  limit: 50,
  stringify: (o) => `${o.name || ""} ${o.contact || ""} ${o.desc || ""}`,
});

function CarTypeOption({ name, image }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
      <Box
        sx={{
          width: 40,
          height: 26,
          flexShrink: 0,
          borderRadius: "6px",
          backgroundColor: C2.lavender,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {image ? (
          <img alt="" src={image} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
        ) : (
          <DirectionsCarOutlinedIcon sx={{ fontSize: 16, color: C2.violet }} />
        )}
      </Box>
      <Typography noWrap sx={{ fontFamily: C2_FONT, fontSize: "0.92rem", color: C2.sidebar }}>
        {name}
      </Typography>
    </Box>
  );
}

const EditCar = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editCar, updateUserCar, updateCarRegistrationImage } = api;
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [driversObj, setDriversObj] = useState("");
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [role, setRole] = useState(null);
  const userdata = useSelector((state) => state.usersdata);
  const [drivers, setDrivers] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const carlistdata = useSelector((state) => state.carlistdata);
  const [driverData, setDriverData] = useState(null);
  const [data, setData] = useState(null);
  const [oldData, setOldData] = useState(null);
  const [carTypeAvailable, setCarTypeAvailable] = useState(null);
  const [carData, setCardata] = useState();
  const [loading, setLoading] = useState(false);
  const {state}=useLocation()

  useEffect(() => {
    if (id) {
      if (carlistdata && carlistdata.cars) {
        const carData = carlistdata.cars.filter(
          (item) => item.id === id.toString()
        )[0];
        if (!carData) {
          navigate("/404");
        }
        setData(carData);
        setOldData(carData);
      }
    } else {
      setData({
        createdAt: new Date().getTime(),
        car_image: DEFAULT_CAR_IMAGE,
        registration_image: null,
        vehicleNumber: "",
        vehicleMake: "",
        carType: "",
        driver: auth && auth.profile.usertype === "driver" ? auth.profile.uid : "",
        vehicleModel: "",
        vehicleColor: "",
        other_info: "",
        active: false,
      });
    }
  }, [carlistdata,id, navigate, auth]);

  useEffect(() => {
    if (carlistdata.cars) {
      setCardata(carlistdata.cars);
    } else {
      setCardata([]);
    }
  }, [carlistdata.cars]);

  useEffect(() => {
    const checkCar = cartypes?.cars.filter(
      (item) => item.name === oldData?.carType
    )[0];
    if (checkCar) {
      setCarTypeAvailable(true);
    } else {
      setCarTypeAvailable(false);
    }
  }, [cartypes, oldData]);

  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({
          id: user.id,
          name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
          contact: settings.AllowCriticalEditsAdmin
            ? [user.mobile, user.email].filter(Boolean).join(" · ")
            : t("hidden_demo"),
          image: user.profile_image || null,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin
              ? user.mobile
              : t("hidden_demo")) +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")),
        });
        obj[user.id] =
          user.firstName +
          " " +
          user.lastName +
          " (" +
          (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) +
          ") " +
          (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
      }
      setDrivers(arr2);
      setDriversObj(obj);
      setFleetMapObj(obj2);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
    t,
  ]);

  useEffect(() => {
    setDriverData(
      auth.profile.firstName +
      " " +
      auth.profile.lastName +
      " (" +
      (settings.AllowCriticalEditsAdmin
        ? auth.profile.mobile
        : t("hidden_demo")) +
      ") " +
      (settings.AllowCriticalEditsAdmin
        ? auth.profile.email
        : t("hidden_demo"))
    );
  }, [
    auth.profile.lastName,
    auth.profile.mobile,
    auth.profile.email,
    settings.AllowCriticalEditsAdmin,
    auth.profile.firstName,
    t,
  ]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handelChangeDriver = (_, option) => {
    if (option) setData({ ...data, driver: option.id });
  };
  const handelChangeCarType = (event) => {
    setData({ ...data, carType: event.target.value });
  };
  const handleInputChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const updateCar = () => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
        setLoading(true);
        setTimeout(() => {
          resolve();
          if (data !== oldData) {
            data['fleetadmin'] = data['driver'] ? (fleetMapObj[data['driver']] ? fleetMapObj[data['driver']] : null) : null;
            delete data.tableData;
            // Aprobado ⇒ activo: evita UI "Aprobado" con perfil carApproved=false / auto inactivo.
            if (data.approved) {
              data.active = true;
            }
            dispatch(editCar(data, "Update"));
            if (data.driver && (data.active || data.approved)) {
              dispatch(updateUserCar(data.driver, {
                carType: data.carType,
                vehicleNumber: data.vehicleNumber,
                vehicleMake: data.vehicleMake,
                vehicleModel: data.vehicleModel,
                vehicleColor: data.vehicleColor || '',
                other_info: data.other_info || '',
                car_image: data.car_image,
                registration_image: data.registration_image || null,
                carApproved: !!data.approved,
                updateAt: new Date().getTime(),
              }));
            }
            if (data.driver !== oldData.driver && oldData.driver && oldData.active) {
              dispatch(updateUserCar(oldData.driver,
                {
                  carType: null,
                  vehicleNumber: null,
                  vehicleMake: null,
                  vehicleModel: null,
                  vehicleColor: null,
                  other_info: null,
                  car_image: null,
                  registration_image: null,
                  carApproved: false,
                  updateAt: new Date().getTime(),
                })
              );
            }
            setLoading(false);
            navigate("/cars",{state:{pageNo:state?.pageNo}});
          } else {
            setLoading(false);
            setCommonAlert({ open: true, msg: t("make_changes_to_update") });
          }
        }, 600);
      })
      : new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          setLoading(false);
          setCommonAlert({ open: true, msg: t("demo_mode") });
        }, 600);
      });
  };

  const addCar = () => {
    if (settings.AllowCriticalEditsAdmin) {
      if (!data.vehicleNumber) {
        setCommonAlert({ open: true, msg: t("car_no_not_found") });
      } else if (!data.vehicleMake) {
        setCommonAlert({ open: true, msg: t("vehicleMake_required") });
      } else if (!data.vehicleModel) {
        setCommonAlert({ open: true, msg: t("vehicleModel_required") });
      } else if (!String(data.vehicleColor || "").trim()) {
        setCommonAlert({ open: true, msg: t("vehicle_color_required") || "El color del vehículo es obligatorio." });
      } else if (!data.driver) {
        setCommonAlert({ open: true, msg: t("driver_required") });
      } else if (!data.carType) {
        setCommonAlert({ open: true, msg: t("carType_required") });
      } else {
        setLoading(true);
        new Promise(resolve => {
          setTimeout(() => {
            let activeCar = null;
            let updateData = {
              carType: data.carType,
              vehicleNumber: data.vehicleNumber,
              vehicleMake: data.vehicleMake,
              vehicleModel: data.vehicleModel,
              vehicleColor: String(data.vehicleColor || "").trim(),
              other_info: data.other_info,
              car_image: data.car_image,
              registration_image: data.registration_image || null,
              updateAt: new Date().getTime()
            }
            for (let i = 0; i < carData.length; i++) {
              if (carData[i].driver === data.driver && carData[i].active) {
                activeCar = carData[i];
                break;
              }
            }
            if (activeCar && data.active) {
              activeCar.active = false;
              dispatch(editCar(activeCar, "Update"));
              dispatch(updateUserCar(data.driver, updateData));
            } else if (activeCar && !data.active) {
              data.active = false;
            } else {
              data.active = true;
              dispatch(updateUserCar(data.driver, updateData));
            }
            data['createdAt'] = new Date().getTime();
            data['fleetadmin'] = data['driver'] ? (fleetMapObj[data['driver']] ? fleetMapObj[data['driver']] : null) : null;
            if (!settings.carApproval) {
              data['approved'] = true;
              if (data.active) {
                dispatch(updateUserCar(data.driver, { carApproved: true }));
              }
            } else {
              data['approved'] = false;
            }
            dispatch(editCar(data, "Add"));
            navigate("/cars");
            setLoading(false);
            resolve();
          }, 600);
        })

      }
    }else{
      setCommonAlert({ open: true, msg: t('demo_mode') });
      setLoading(false);
    }
  };


  const goBack = () => navigate("/cars", { state: { pageNo: state?.pageNo } });
  const dir = isRTL === "rtl" ? "rtl" : "ltr";
  const fieldSx = isRTL === "rtl" ? { ...c2TextFieldSx, ...c2RtlFieldSx } : c2TextFieldSx;
  const locked = !!data?.active;
  const menuItemSx = { fontFamily: C2_FONT, direction: dir, whiteSpace: "normal" };
  const carTypeImage = (name) => cartypes?.cars?.find((c) => c.name === name)?.image || null;
  const previewImage =
    data?.car_image && data.car_image !== DEFAULT_CAR_IMAGE
      ? data.car_image
      : data?.carType
        ? carTypeImage(data.carType)
        : null;
  const vehicleLabel = [data?.vehicleMake, data?.vehicleModel].filter(Boolean).join(" · ");

  return loading ? (
    <CircularLoading />
  ) : (
    <Box sx={{ direction: dir }}>
      <Box
        sx={{
          backgroundColor: C2.white,
          border: `1px solid ${C2.border}`,
          borderRadius: "18px",
          boxShadow: "0 8px 24px rgba(26,15,59,0.06)",
          p: { xs: 2, sm: 3 },
          maxWidth: 1100,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0 }}>
            <Box
              sx={{
                width: 72,
                height: 56,
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                p: previewImage ? 0.75 : 0,
                backgroundColor: previewImage ? C2.lavender : "transparent",
                border: previewImage ? `1px solid ${C2.border}` : "none",
                background: previewImage ? undefined : `linear-gradient(135deg, ${C2.violet}, ${C2.bright})`,
                boxShadow: previewImage ? "none" : "0 6px 16px rgba(100,17,237,0.28)",
              }}
            >
              {previewImage ? (
                <img alt="Car" src={previewImage} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
              ) : (
                <DirectionsCarOutlinedIcon sx={{ color: C2.white, fontSize: 30 }} />
              )}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontFamily: C2_FONT,
                  fontWeight: 800,
                  fontSize: { xs: "1.15rem", sm: "1.35rem" },
                  color: C2.sidebar,
                  lineHeight: 1.2,
                }}
              >
                {id ? t("update_car_title") : t("add_car_title")}
              </Typography>
              <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.88rem", color: C2.muted, mt: 0.25 }}>
                {id && data?.vehicleNumber
                  ? `Editando: ${data.vehicleNumber}${vehicleLabel ? ` · ${vehicleLabel}` : ""}`
                  : "Registra un vehículo y asígnalo a un conductor."}
              </Typography>
              {id && data ? (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1 }}>
                  <C2StatusChip tone={data.active ? "success" : "neutral"} label={data.active ? "Activo" : "Inactivo"} />
                  <C2StatusChip
                    tone={data.approved ? "violet" : "warning"}
                    label={data.approved ? "Aprobado" : "Pendiente de aprobación"}
                  />
                </Box>
              ) : null}
            </Box>
          </Box>
          <Button
            variant="outlined"
            startIcon={<ArrowBackRoundedIcon sx={{ transform: isRTL === "rtl" ? "scaleX(-1)" : "none" }} />}
            onClick={goBack}
            sx={c2SecondaryBtnSx}
          >
            {t("go_back")}
          </Button>
        </Box>

        {locked ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 1.25,
              p: 1.5,
              mb: 2.5,
              borderRadius: "12px",
              backgroundColor: C2.bg,
              border: `1px solid ${C2.border}`,
            }}
          >
            <LockOutlinedIcon sx={{ color: C2.violet, fontSize: 20, mt: "2px" }} />
            <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.85rem", color: C2.deep, lineHeight: 1.45 }}>
              Este vehículo está activo, por eso sus datos y el tipo de vehículo no se pueden editar. Desactívalo desde la lista de vehículos para modificarlos.
            </Typography>
          </Box>
        ) : null}

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <FormSection
            icon={BadgeOutlinedIcon}
            title="Datos del vehículo"
            subtitle="Placa, marca, modelo, color y tarjeta de propiedad para verificación."
          >
            <Grid item xs={12} md={6}>
              <TextField
                label={t("vehicle_reg_no")}
                id={"vehicleNumber"}
                value={data?.vehicleNumber || ""}
                disabled={locked}
                fullWidth
                onChange={handleInputChange}
                sx={{
                  ...fieldSx,
                  "& .MuiInputBase-input": {
                    ...fieldSx["& .MuiInputBase-input"],
                    fontWeight: 700,
                    letterSpacing: "0.08em",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={t("vehicle_model_name")}
                id={"vehicleMake"}
                value={data?.vehicleMake || ""}
                disabled={locked}
                fullWidth
                onChange={handleInputChange}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={t("vehicle_model_no")}
                id={"vehicleModel"}
                value={data?.vehicleModel || ""}
                disabled={locked}
                fullWidth
                onChange={handleInputChange}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={(t("vehicle_color") || "Color") + " *"}
                id={"vehicleColor"}
                value={data?.vehicleColor || ""}
                disabled={locked}
                fullWidth
                required
                onChange={handleInputChange}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label={t("other_info")}
                id={"other_info"}
                value={data?.other_info || ""}
                disabled={locked}
                fullWidth
                onChange={handleInputChange}
                sx={fieldSx}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: "0.85rem", color: C2.sidebar, mb: 1 }}>
                {t("registration_card") || "Tarjeta de propiedad"}
              </Typography>
              {data?.registration_image ? (
                <Box
                  sx={{
                    borderRadius: "12px",
                    border: `1px solid ${C2.border}`,
                    overflow: "hidden",
                    mb: 1,
                    backgroundColor: C2.bg || "#F4F2FE",
                    maxHeight: 160,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    alt="registration"
                    src={data.registration_image}
                    style={{ maxWidth: "100%", maxHeight: 160, objectFit: "contain" }}
                  />
                </Box>
              ) : (
                <Typography sx={{ fontFamily: C2_FONT, fontSize: "0.8rem", color: C2.muted, mb: 1 }}>
                  Sin imagen de matrícula / propiedad
                </Typography>
              )}
              {id && settings.AllowCriticalEditsAdmin ? (
                <Button
                  component="label"
                  variant="outlined"
                  disabled={loading}
                  sx={c2SecondaryBtnSx}
                >
                  {t("upload_registration_image") || "Subir tarjeta de propiedad"}
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={async (event) => {
                      const file = event.target.files?.[0];
                      if (!file || !data?.id) return;
                      setLoading(true);
                      try {
                        const url = await dispatch(updateCarRegistrationImage(data, file));
                        if (url) setData((d) => ({ ...d, registration_image: url }));
                        setCommonAlert({ open: true, msg: t("profile_updated") || "Actualizado" });
                      } catch (e) {
                        setCommonAlert({ open: true, msg: e?.message || "Error al subir" });
                      } finally {
                        setLoading(false);
                        event.target.value = "";
                      }
                    }}
                  />
                </Button>
              ) : null}
            </Grid>
          </FormSection>

          <FormSection
            icon={AssignmentIndOutlinedIcon}
            title="Asignación"
            subtitle="Conductor responsable y tipo de servicio que prestará."
          >
            <Grid item xs={12} md={6}>
              {role === "admin" || role === "fleetadmin" ? (
                <Autocomplete
                  id="editcar-driver"
                  options={drivers || []}
                  value={(drivers || []).find((d) => d.id === data?.driver) || null}
                  onChange={handelChangeDriver}
                  getOptionLabel={(o) => driversObj[o.id] || o.desc || ""}
                  isOptionEqualToValue={(a, b) => a?.id === b?.id}
                  filterOptions={driverFilterOptions}
                  disableClearable
                  noOptionsText="No encontramos conductores con esa búsqueda"
                  slotProps={{
                    paper: {
                      sx: {
                        fontFamily: C2_FONT,
                        borderRadius: "12px",
                        border: `1px solid ${C2.border}`,
                        boxShadow: "0 12px 28px rgba(26,15,59,0.12)",
                      },
                    },
                  }}
                  renderOption={(props, o) => (
                    <Box component="li" {...props} key={o.id} sx={{ ...menuItemSx, gap: 1.25 }}>
                      <Avatar
                        src={o.image || undefined}
                        sx={{ width: 32, height: 32, fontSize: "0.85rem", bgcolor: C2.lavender, color: C2.violet, fontWeight: 700 }}
                      >
                        {(o.name || "?").charAt(0).toUpperCase()}
                      </Avatar>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography noWrap sx={{ fontFamily: C2_FONT, fontWeight: 700, fontSize: "0.9rem", color: C2.sidebar }}>
                          {o.name || "—"}
                        </Typography>
                        <Typography noWrap sx={{ fontFamily: C2_FONT, fontSize: "0.76rem", color: C2.muted }}>
                          {o.contact}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("driver")}
                      placeholder="Buscar por nombre, teléfono o correo"
                      sx={fieldSx}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <SearchRoundedIcon sx={{ color: C2.muted, fontSize: 20, ml: 0.5, mr: 0.25 }} />
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              ) : (
                <TextField
                  label={t("driver")}
                  value={role === "driver" ? driverData || "" : ""}
                  disabled
                  fullWidth
                  sx={fieldSx}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth sx={fieldSx}>
                <InputLabel id="editcar-cartype-label">{t("car_type")}</InputLabel>
                <Select
                  labelId="editcar-cartype-label"
                  id="editcar-cartype"
                  value={data?.carType || ""}
                  label={t("car_type")}
                  onChange={handelChangeCarType}
                  disabled={locked}
                  sx={{ fontFamily: C2_FONT, color: C2.sidebar }}
                  MenuProps={{ PaperProps: { sx: { borderRadius: "12px" } } }}
                >
                  {!carTypeAvailable ? (
                    <MenuItem value={oldData?.carType} sx={menuItemSx}>
                      <CarTypeOption name={t(getLangKey(oldData?.carType ? oldData?.carType : ""))} />
                    </MenuItem>
                  ) : null}
                  {cartypes?.cars
                    ? cartypes.cars.map((e) => (
                      <MenuItem key={e.id} value={e.name} sx={menuItemSx}>
                        <CarTypeOption name={t(getLangKey(e.name ? e.name : ""))} image={e.image} />
                      </MenuItem>
                    ))
                    : null}
                </Select>
              </FormControl>
            </Grid>
          </FormSection>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: 1.5,
            mt: 3,
            pt: 2.5,
            borderTop: `1px solid ${C2.lavender}`,
          }}
        >
          <Button variant="outlined" onClick={goBack} sx={{ ...c2SecondaryBtnSx, minWidth: 140 }}>
            {t("cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (id) {
                updateCar();
              } else {
                addCar();
              }
            }}
            sx={{ ...c2PrimaryBtnSx, minWidth: 200, py: 1.25, fontSize: "1rem" }}
          >
            {id ? t("update") : t("add")}
          </Button>
        </Box>
      </Box>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </Box>
  );
}

export default EditCar;
